import { WorkOrderExternalSnapshot } from '@myapp/contract'

/**
 * Returns a short location label for calendar blocks — just the city/district (Ort).
 *
 * gebaeude = "Nr 5, Hauptstraße, Berlin Mitte"  → "Berlin Mitte"
 * veAdresse = "Nr 123, Bezeichnung, Hauptstraße 5, 12345 Berlin" → "Berlin" (PLZ stripped)
 */
export function shortLocation(ext: WorkOrderExternalSnapshot | null | undefined): string | null {
  if (!ext) return null

  if (ext.gebaeude) {
    const parts = ext.gebaeude.split(', ')
    return parts[0] || null
  }

  if (ext.veAdresse) {
    const parts = ext.veAdresse.split(', ')
    const last = parts[parts.length - 1] ?? ''
    // strip leading PLZ (5 digits + space), e.g. "12345 Berlin" → "Berlin"
    return last.replace(/^\d{5}\s*/, '') || null
  }

  return null
}
